import React from 'react';
import { useTheme } from 'styled-components';

import { getColor } from '../../V2/Elements/Icons/helpers.ts';
import type { IIcon } from './types.ts';

const Icon = React.forwardRef<SVGSVGElement | null, IIcon>(function Icon({ size = 24, alt, color, className, onClick }, ref) {
  const theme = useTheme();
  const fillColor = React.useMemo(() => getColor({ color, alt, theme }), [color, alt, theme]);
  return (
    <svg ref={ref} onClick={onClick} width={size} height={size} viewBox='0 0 426.667 426.667' fill='none' className={className}>
      <polygon fillRule='evenodd' clipRule='evenodd' points='170.667,309.333 298.667,213.333 170.667,117.333 ' fill={fillColor} />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M213.333,0C95.467,0,0,95.467,0,213.333s95.467,213.333,213.333,213.333S426.667,331.2,426.667,213.333 S331.2,0,213.333,0z M213.333,384c-94.08,0-170.667-76.587-170.667-170.667S119.253,42.667,213.333,42.667 S384,119.253,384,213.333S307.413,384,213.333,384z'
        fill={fillColor}
      />
    </svg>
  );
});

export default React.memo(Icon);
